import { useQuery } from '@tanstack/react-query'

import { requestBusinessObjects } from 'shared/services'
import { useJWTToken } from 'App/Auth'

const getUserLocations = ({ queryKey: [
    _key, // eslint-disable-line no-unused-vars
    { token },
] }) => {
    return requestBusinessObjects({
        method: 'GET',
        url: 'contact/self',
        token,
    })
        .then((data) => {
            return data.data.location
        })
}

function useUserLocations() {
    const token = useJWTToken()

    return useQuery({
        queryKey: [
            'getUserLocation',
            { token },
        ],
        queryFn: getUserLocations,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
    })
}

export default useUserLocations
